import LoadingIndicator, { TYPES } from './LoadingIndicator.jsx';

export default LoadingIndicator;
export { TYPES };
